var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 2H11.8C11.4684 2 11.2 2.26841 11.2 2.6C11.2 2.93159 11.4684 3.2 11.8 3.2H14.2C14.5316 3.2 14.8 2.93159 14.8 2.6C14.8 2.26841 14.5316 2 14.2 2Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0H7.19999C5.8768 0 4.79999 1.07681 4.79999 2.4V21.6C4.79999 22.9232 5.8768 24 7.19999 24H16.8C18.1232 24 19.2 22.9232 19.2 21.6V2.4C19.2 1.07681 18.1232 0 16.8 0ZM18 21.6C18 22.2628 17.4628 22.8 16.8 22.8H7.19999C6.53718 22.8 5.99999 22.2628 5.99999 21.6V2.4C5.99999 1.73719 6.53718 1.2 7.19999 1.2H16.8C17.4628 1.2 18 1.73719 18 2.4V21.6Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0001C12.6627 22.0001 13.2 21.4628 13.2 20.8001C13.2 20.1374 12.6627 19.6001 12 19.6001C11.3372 19.6001 10.8 20.1374 10.8 20.8001C10.8 21.4628 11.3372 22.0001 12 22.0001Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80001 3.2C10.1314 3.2 10.4 2.93137 10.4 2.6C10.4 2.26863 10.1314 2 9.80001 2C9.46864 2 9.20001 2.26863 9.20001 2.6C9.20001 2.93137 9.46864 3.2 9.80001 3.2Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmartphone);
export default __webpack_public_path__ + "static/media/ic-smartphone.c727130fd210ca06e70edd66c3a18b16.svg";
export { ForwardRef as ReactComponent };